<!-- https://8es9hr.axshare.com/#g=1&p=%E6%89%8B%E5%8B%95%E6%9C%88%E7%B5%90%E4%BD%9C%E6%A5%AD
	 https://8es9hr.axshare.com/#g=1&p=%E6%89%8B%E5%8B%95%E6%9C%88%E7%B5%90%E4%BD%9C%E6%A5%AD___12_%E6%9C%88%E4%BB%BD__ -->
<!-- 手動月結作業 -->
<template>
	<div class="row">
		<div class="col-12">
			<div class="col-block">
				<div class="block-header has-border">
					<h3>
						<strong>月結報表</strong>
					</h3>
					<br />
				</div>
				<div class="block-content">
					<div>現在日期 : {{ nowTime }}</div>
					<div class="mt10">
						<div class="mb10">切換月結月份</div>
						<template>
							<el-select
								v-model="years"
								placeholder="請選擇年分"
								class="select-set mb10"
							>
								<el-option
									v-for="year in yearList"
									:key="year"
									:label="parseInt(year) - 1911"
									:value="year"
								></el-option>
							</el-select>
							<el-select
								v-model="months"
								placeholder="請選擇"
								class="select-set mb10"
							>
								<el-option
									v-for="month in monthList[years]"
									:key="month"
									:label="month"
									:value="month"
								></el-option>
							</el-select>
							<div>
								<el-button
									type="primary"
									plain
									class="mt10"
									v-if="btnshow"
									@click="getData(years, months)"
									>前往月結報表</el-button
								>
							</div>
						</template>
					</div>
					<div v-if="recordToEdit.coopMonthStl">
						<h3 class="title mt10">
							<strong>{{ dateShow }} 月結作業</strong>
						</h3>
						<br />
						<div>
							<div>
								<!-- 手動設定並提列備轉金息 -->
								<div v-if="false">
									<h3 class="title mt10">
										<strong>提列備轉金息</strong>
									</h3>
									<br />備轉金息率設定
									<el-input
										style="width: 200px"
										v-model="transferRate"
									>
										<template slot="append">%</template>
									</el-input>
									<br />
									<el-button
										type="primary"
										plain
										class="mt10"
										@click="createForm"
										>產生提列分錄</el-button
									>
								</div>

								<div
									v-if="
										recordToEdit
											.coopMonthTransferAmountInterest
											.main.length > 0 && months == '12'
									"
								>
									<table
										class="table table-bordered mb-0 mt10"
									>
										<thead class="grey lighten-4">
											<tr>
												<th>科目代號</th>
												<th>科目名稱</th>
												<th>借方金額</th>
												<th>貸方金額</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(
													item, key
												) in recordToEdit
													.coopMonthTransferAmountInterest
													.main"
												:key="key"
											>
												<td>
													{{ item.accountTitleCode }}
												</td>
												<td>
													{{ item.accountTitleName }}
												</td>
												<td>
													{{
														$addcomma(
															item.creditAmount
														)
													}}
												</td>
												<td>
													{{
														$addcomma(
															item.debitAmount
														)
													}}
												</td>
											</tr>
										</tbody>
									</table>
									<el-button
										type="primary"
										plain
										class="mt10"
										@click="showDetail"
										>檢視明細</el-button
									>
								</div>
							</div>

							<div>
								<h3 class="title mt10">
									<strong>財產折舊提列</strong>
								</h3>
								<table class="table table-bordered mb-0 mt10">
									<thead class="grey lighten-4">
										<tr>
											<th></th>
											<th>財產編號</th>
											<th>財產名稱</th>
											<th>購買日期</th>
											<th>取得總價</th>
											<th>估計殘值</th>
											<th>使用年限(年)</th>
											<th>累計折舊金額</th>
											<th>帳面價值</th>
											<th>本月提列金額</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(
												item, idx
											) in recordToEdit.coopMonthStlCpi"
											:key="idx"
										>
											<td class="text-center">
												{{ idx + 1 }}
											</td>

											<td>{{ item.code }}</td>
											<td>{{ item.name }}</td>
											<td v-if="item.dateOfPurchase">
												{{
													item.dateOfPurchase
														| datechange
												}}
											</td>
											<td v-else></td>
											<td>
												{{ item.totalPrice | addcomma }}
											</td>
											<td>
												{{
													item.estimatedResidualValue
														| addcomma
												}}
											</td>
											<td>{{ item.yearsOfUse }}</td>
											<td>
												{{
													item.totalDepcAmount
														| addcomma
												}}
											</td>
											<!-- <td>{{item.totalPrice && item.depcAmount ? item.totalPrice - item.depcAmount : ''}}</td> -->
											<td>
												{{
													item.bookValue | addcomma
												}}
											</td>
											<td>
												{{ item.depcAmount | addcomma }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- LPLS 申報表額填報資訊 -->
							<!-- <h3 class="mt-3" style="font-weight:bold;">LPLS 申報表額填報資訊</h3>
                            <table class="table table-bordered mb-0 mt10">
                                <thead class="grey lighten-4">
                                    <tr>
                                        <th width="700">其他應扣股金 ( LS列舉細目 )</th>
                                        <th width="400">本次補助金額</th>
                                        <th>已由公積金沖銷之貸款結餘</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center td-set">
                                            <el-input
                                                v-model="thisRecord.otherName1"
                                                class="mr-3 flex-set"
                                                :disabled="true"
                                            ></el-input>
                                            <el-input-number
                                                v-model="thisRecord.otherAmount1"
                                                class="input-set"
                                                :disabled="true"
                                                :controls="false"
                                                placeholder="請填寫金額"
                                            ></el-input-number>
                                        </td>
                                        <td class="text-left">
                                            <span class="span-set">本次補繳 -</span>
                                            <el-input-number
                                                v-model="thisRecord.markeupAmount"
                                                :controls="false"
                                                class="input-set"
                                                placeholder="請填寫本次補繳金額"
                                            ></el-input-number>
                                        </td>
                                        <td class="text-center">
                                            <el-input
                                                class
                                                placeholder="請填寫結餘"
                                                v-model="thisRecord.reversalAmount"
                                            ></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center td-set">
                                            <el-input
                                                v-model="thisRecord.otherName2"
                                                class="mr-3 flex-set"
                                                placeholder="請填寫細項"
                                            ></el-input>
                                            <el-input-number
                                                v-model="thisRecord.otherAmount2"
                                                :controls="false"
                                                class="input-set"
                                                placeholder="請填寫金額"
                                            ></el-input-number>
                                        </td>
                                        <td class="text-left">
                                            <span class="span-set">本次抵繳 -</span>

                                            <el-input-number
                                                v-model="thisRecord.creditAmount"
                                                :controls="false"
                                                class="input-set"
                                                placeholder="請填寫本次抵繳金額"
                                            ></el-input-number>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center td-set">
                                            <el-input
                                                v-model="thisRecord.otherName3"
                                                class="mr-3 flex-set"
                                                placeholder="請填寫細項"
                                            ></el-input>
                                            <el-input-number
                                                v-model="thisRecord.otherAmount3"
                                                :controls="false"
                                                class="input-set"
                                                placeholder="請填寫金額"
                                            ></el-input-number>
                                        </td>
                                        <td class="text-left">
                                            <span class="span-set">本次匯款 -</span>
                                            <el-input-number
                                                v-model="thisRecord.remitAmount"
                                                :controls="false"
                                                class="input-set"
                                                placeholder="請填寫本次抵繳金額"
                                            ></el-input-number>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>-->

							<!-- 相關報表 -->

							<h3 class="title mt10 mb10">
								<strong>相關報表</strong>
							</h3>
							<br />
							<div>
								<el-row>
									<div class="my-2" style="font-weight: bold">
										月結報表
									</div>
									<el-button
										type="primary"
										plain
										@click="dialogShowPdf(item)"
										v-for="(item, idx) in buttonGroup[0]"
										:key="idx"
										>{{ item.label }}</el-button
									>
								</el-row>
								<el-row>
									<div class="my-2" style="font-weight: bold">
										LPLS申報表
									</div>
									<el-button
										type="primary"
										plain
										@click="dialogShowPdf(item)"
										v-for="(item, idx) in buttonGroup[1]"
										:key="idx"
										>{{ item.label }}</el-button
									>
								</el-row>
								<el-row>
									<div class="my-2" style="font-weight: bold">
										資料查印
									</div>
									<el-button
										type="primary"
										plain
										@click="dialogShowPdf(item)"
										v-for="(item, idx) in buttonGroup[2]"
										:key="idx"
										>{{ item.label }}</el-button
									>
								</el-row>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- dialog 顯示pdf -->
		<el-dialog
			:visible.sync="dialogListFormPrint"
			:modal-append-to-body="true"
			:modal="true"
			:append-to-body="true"
			:show-close="false"
			ref="dailog"
			:fullscreen="true"
			id="loadingDialog"
		>
			<h3
				v-if="select.label"
				class="text-center"
				style="font-weight: bold"
			>
				{{ select.label }}
			</h3>
			<div class="show-container">
				<!-- <iframe style="width:100%;height:100%;"
                            :src="`${getUrl}`"
                            ref="pdfViewr"
                            id="ifm"
                ></iframe>-->
				<div class="show"></div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="dialogListFormPrint = false"
					plain
					>關閉</el-button
				>
			</div>
		</el-dialog>

		<!-- dialog 顯示提列明細 -->
		<el-dialog
			:visible.sync="dialogLDetail"
			:modal-append-to-body="true"
			:modal="true"
			:append-to-body="true"
			:show-close="false"
			width="70%"
			class="loadingDialog"
		>
			<h3 class="text-center mb-4" style="font-weight: bold">明細檢視</h3>
			<el-table
				:data="transferRowInfoList"
				max-height="600"
				stripe
				border
			>
				<el-table-column
					type="index"
					align="center"
					width="100"
					fixed
				></el-table-column>
				<el-table-column
					v-for="(item, index) in DetailColumns"
					:prop="item.prop"
					:label="item.label"
					:key="index"
					width="180"
				>
					<template slot-scope="scope">
						<div v-if="item.addcomma">
							{{ $addcomma(scope.row[item.prop]) }}
						</div>
						<div v-else>{{ scope.row[item.prop] }}</div>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";
import moment from "moment";
export default {
	components: { Workbench },
	name: "manual_monthly",
	data() {
		return {
			transferRowInfoList: [],
			yearList: [],
			monthList: { "": [] },
			years: "",
			months: "",
			currentDate: "",
			btnshow: false,

			showList: false,
			test: "",
			coopId: "",

			select: {},
			getUrl: "",

			dateShow: "",
			thisRecord: {
				otherName1: "股金超過3,000元不保",
				otherAmount1: "",
				otherName2: "",
				otherAmount2: "",
				otherName3: "",
				otherAmount3: "",
				markeupAmount: "",
				creditAmount: "",
				remitAmount: "",
				reversalAmount: "",
			},
			options: [],
			testtinn: [],
			singleMonth: "",

			dates: "",
			monthDay: "",
			tranferDate: "",
			transferRate: "",
			reportBaseDate: "",
			recordToEdit: {},
			dialogListFormPrint: false,
			dialogLDetail: false,
			amount: Number,
			show: false,
			nowTime: "",
			normalTime: "",
			currentMonth: "",

			reportId: "",

			toolbar: {
				/*    addable: false,
                editable: true,
                select: false,
                removeable: false, */
				search: false,
				allClose: true,
			},
			toolbar2: {
				select: false,
				editable: false,
				addable: false,
			},
			columns: [
				{
					label: "財產編號",
					prop: "",
				},
				{
					label: "財產名稱",
					prop: "",
				},
				{
					label: "購買日期",
					prop: "",
				},
				{
					label: "取得總價",
					prop: "",
				},
				{
					label: "估計殘值",
					prop: "",
				},
				{
					label: "使用年限(年)",
					prop: "",
				},
				{
					label: "累計折舊金額",
					prop: "",
				},
				{
					label: "帳面價值",
					prop: "",
				},
				{
					label: "本月提列金額",
					prop: "",
				},
			],
			DetailColumns: [
				{ prop: "memberAccount", label: "社員帳號" },
				{ prop: "memberName", label: "社員姓名" },
				{
					prop: "transferAmountTotal",
					label: "備轉金結餘",
					addcomma: true,
				},
				{
					prop: "memberTransferCardinal",
					label: "備轉金積數",
					addcomma: true,
				},
				{
					prop: "transferAmountPay",
					label: "備轉金息",
					addcomma: true,
				},
			],
			buttonGroup: [
				//使用群組方式 去新增pdf
				[
					{
						label: "損益表",
						name: "profit_loss",
						action: "IncomeStatementPdf",
						type: "type1",
					},
					{
						label: "呆帳沖銷記錄",
						name: "lpls_report",
						action: "IouDeadListPdf",
						type: "type1",
					},
					{
						label: "財務業務統計報告表",
						name: "financial_business",
						action: "FinancialAndBusinessListPdf",
						type: "type1",
					},
					{
						label: "放款資產評估明細表",
						name: "lpls_report",
						action: "LoanAssetListPdf",
						type: "type1",
					},
				],
				[
					{
						label: "逾齡備轉金",
						name: "lpls_report",
						action: "OverageAllowance",
						type: "type2",
					},
					{
						label: "法人備轉金",
						name: "lpls_report",
						action: "CorporateTransfer",
						type: "type2",
					},
					{
						label: "不合格放款",
						name: "lpls_report",
						action: "UnqualifiedLoan",
						type: "type2",
					},
					{
						label: "超額備轉金",
						name: "lpls_report",
						action: "ExcessTransfer",
						type: "type2",
					},
					{
						label: "逾齡股金及放款",
						name: "lpls_report",
						action: "OveragedSharesLoans",
						type: "type2",
					},
					{
						label: "超額股金及放款",
						name: "lpls_report",
						action: "ExcessCapitalLoans",
						type: "type2",
					},
					{
						label: "法人股金及放款",
						name: "lpls_report",
						action: "LegalPersonSharesLoans",
						type: "type2",
					},
					{
						label: "股金超過3000元",
						name: "lpls_report",
						action: "OverStockAmount",
						type: "type2",
					},
					{
						label: "逾齡附加放款清冊",
						name: "lpls_report",
						action: "OverageAdditionalLoanInventory",
						type: "type2",
					},
					{
						label: "逾期十八個月放款",
						name: "lpls_report",
						action: "Overdue18MonthsLoan",
						type: "type2",
					},
					// {
					//     label: "互助費LPLS申報表",
					//     name: "lpls_report",
					//     action: "LPLSMonth",
					//     type: "type2"
					// },
					{
						label: "青年附加契約明細表",
						name: "lpls_report",
						action: "YoungAdditional",
						type: "type2",
					},
					{
						label: "LS個人最高給付額表",
						name: "lpls_report",
						action: "LSStockAmountLimit",
						type: "type2",
					},
				],
				[
					{
						label: "社員名冊",
						name: "member_roster",
						action: "MemberPdf",
						params: {
							accountStart: "000000",
							accountEnd: "999999",
							isFormal: "1",
						},
						type: "type3",
					},
					{
						label: "放款一覽表",
						name: "loan_list",
						action: "LendingListPdf",
						type: "type3",
					},
					{
						label: "放款逾期一覽表",
						name: "loan_overdue",
						action: "LoanOverdueListPdf",
						type: "type3",
					},
				],
			],
		};
	},
	created() {
		this.coopId = localStorage.getItem("coopId");
		this.getMonthStlList();
		this.getTime();
		// this.getnormalTime();
		this.getcurrentMonth();
		this.getYearSelect();
		this.tranferDate = this.nowTime.substr(0, 6);
		// this.getData();
	},
	computed: {
		// detailForm() {
		//     return this.;
		// }
	},
	watch: {
		months: {
			handler(NewVal) {
				let Y = parseInt(this.years) - 1911;
				let M = parseInt(this.months);
				let A = `${Y}-${M}`;
				this.btnshow = NewVal !== "";
				this.recordToEdit = {};
				return (this.tranferDate = A);
			},
		},
		years: {
			handler(NewVal) {
				this.months = "";
			},
		},
	},
	methods: {
		finalAmomut(item) {
			if (item.totalPrice && item.depcAmount) {
				return item.totalPrice - item.depcAmount;
			} else if (item.totalPrice && !item.depcAmount) {
				return item.totalPrice;
			} else if (!item.totalPrice && item.depcAmount) {
				return item.depcAmount;
			} else {
				return "";
			}
		},
		getData(years, months) {
			const vm = this;

			years = `${years}-${months}-${vm.currentDate.split("-")[2]}`;
			let url =
				API.coopMonthStl +
				`?action=GetStlByDate&baseDate=${
					years ? years : vm.currentDate
				}&coopMonthStlDate`;
			const thenCB = (json) => {
				if (json.resultData.data) {
					this.recordToEdit = json.resultData.data;
					this.monthDay =
						json.resultData.data.coopMonthStlDate.substr(8, 2);
					this.dateShow = this.tranferDate;
				}
				this.reportBaseDate = json.resultData.data.coopMonthStlDate;
			};
			this.mAxiosGet(url, thenCB);
		},
		getMonthStlList() {
			let url = API.coopMonthStl + `?action=GetStlList`;
			const thenCB = (json) => {
				this.yearList = Object.keys(json.resultData);
				this.monthList = json.resultData;
			};

			this.mAxiosGet(url, thenCB);
		},
		getTime() {
			const vm = this;
			let date = new Date();
			let Y = date.getFullYear() - 1911;
			let M = date.getMonth() + 1;
			let D = date.getDate();
			let times =
				Y +
				`-` +
				(M < 10 ? "0" : "") +
				M +
				`-` +
				(D < 10 ? "0" : "") +
				D;
			return (vm.nowTime = times);
		},

		getcurrentMonth() {
			const vm = this;
			let date = new Date();
			let Y = date.getFullYear();
			let M = date.getMonth() + 1;
			let D = date.getDate();
			let A = `${Y}-${M}-${D}`;
			this.currentDate = A;
		},
		getYearSelect() {
			let dateArray = [];
			for (let i = 0; i < 36; i++) {
				dateArray.push(
					moment().subtract(i, "month").format("YYYY-MM-DD")
				);
			}
			this.options = dateArray.map((val) => {
				const form = {
					label: `${val.substring(0, 4) - 1911}-${val.substring(
						5,
						7
					)}`,
					value: val,
				};
				return form;
			});
		},
		dialogShowPdf(item) {
			this.select = item;
			this.open(this.select);
		},
		open(select) {
			this.dialogListFormPrint = true;
			const removeEl = document.querySelector(".show-container iframe");
			let loadingDialog = document.getElementById("loadingDialog");
			if (removeEl !== null) {
				removeEl.remove();
			}
			let url = "";
			// get 參數
			let params = {
				// action: select.action,
				// blanceDate: this.years,
			};
			if (select.type == "type1") {
				if (select.label == "放款資產評估明細表") {
					url = API.coopMonthReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
						loanType: "0",
						possibilityType: "0",
						accountStart: "000000",
						accountEnd: "999999",
					};
				} else if (select.label == "財務業務統計報告表") {
					url = API.coopMonthReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
						accountStart: "000000",
						accountEnd: "999999",
					};
				} else {
					url = API.coopMonthReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
					};
				}
			} else if (select.type == "type2") {
				if (select.query) {
					url = API.coopReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
						otherName1: this.thisRecord.otherName1 || "",
						otherAmount1: "",
						otherBalance1: this.thisRecord.otherBalance1 || "",
						otherName2: this.thisRecord.otherName2 || "",
						otherAmount2: this.thisRecord.otherAmount2 || "",
						otherBalance2: this.thisRecord.otherBalance1 || "",
						otherName3: this.thisRecord.otherName3 || "",
						otherAmount3: this.thisRecord.otherAmount3 || "",
						markeupAmount: this.thisRecord.markeupAmount,
						creditAmount: this.thisRecord.creditAmount,
						remitAmount: this.thisRecord.remitAmount,
					};
				} else if (select.label == "互助費LPLS申報表") {
					url = API.coopLplsReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						accountStart: "000000",
						accountEnd: "999999",
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
						otherName1: this.thisRecord.otherName1 || "",
						otherName2: this.thisRecord.otherName2 || "",
						otherName3: this.thisRecord.otherName3 || "",
						otherAmount1: "",
						otherAmount2: this.thisRecord.otherAmount2 || "",
						otherAmount3: this.thisRecord.otherAmount3 || "",
					};
				} else if (select.label == "青年附加契約明細表") {
					url = API.coopLplsReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						accountStart: "000000",
						accountEnd: "999999",
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
					};
				} else {
					url = API.coopLplsReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
					};
				}
			} else if (select.type == "type3") {
				if (select.label == "放款一覽表") {
					url = API.coopReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						accountStart: "000000",
						accountEnd: "999999",
						filterType: 0,
						sortType: 1,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
					};
				} else if (select.label == "社員名冊") {
					url = API.coopReport;
					params = {
						action: select.action,
						accountStart: "000000",
						accountEnd: "999999",
						isFormal: "1",
					};
				} else if (select.label == "放款逾期一覽表") {
					url = API.coopReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
						memberOption: "0",
						isSortByOverDueMonth: "0",
					};
				} else {
					url = API.coopReport;
					params = {
						action: select.action,
						balanceDate: this.reportBaseDate,
						reportId: this.recordToEdit.coopMonthStl[0].reportId,
					};
				}
			}

			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
				target: loadingDialog, //載入目標設定為dialog
			});
			this.$http
				.get(url, { responseType: "blob", params })
				.then((response) => {
					let blob = new Blob([response.data], {
						type: "application/pdf",
					});
					let iframe = document.createElement("iframe");
					iframe.setAttribute("height", "100%");
					iframe.setAttribute("width", "100%");
					iframe.setAttribute("id", "ifm");
					let showDom = document.getElementsByClassName("show")[0];
					iframe.src = window.URL.createObjectURL(blob);
					showDom.appendChild(iframe);
					loading.close();
				})
				.catch((error) => {
					const reader = new FileReader();
					reader.addEventListener("loadend", (e) => {
						const result = JSON.parse(e.srcElement.result);
						loading.close();
						this.$message.closeAll();
						this.$message({
							type: "error",
							message: result.ErrorMessage,
							duration: 5000,
						});
					});
					reader.readAsText(error.response.data);

					this.dialogListFormPrint = false;
				});
		},
		createForm() {
			let url = API.coopMonthStl + `?action=SetTransfer`;
			const form = new FormData();
			form.append("coopMonthStlId", this.recordToEdit.coopMonthStl[0].id);
			form.append("transferRate", this.transferRate);
			const thenCB = (json) => {
				this.getData(this.years);
			};

			this.mAxiosPost(url, form, thenCB);
		},
		showDetail() {
			let url =
				API.coopMonthStl +
				`?action=GetMemberTradeByCoopMonthStlId&coopMonthStlId=${this.recordToEdit.coopMonthStl[0].id}`;
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			const thenCB = (json) => {
				this.transferRowInfoList = json.resultData.data;
				this.dialogLDetail = true;
				loading.close();
			};

			this.mAxiosGet(url, thenCB);
		},
		editData() {},
	},
};
</script>
<style lang="scss" scoped>
.el-row {
	button {
		margin-left: 0;
		margin-right: 10px;
		margin-bottom: 10px;
	}
}
.subBtn {
	text-align: center;
}
.input-set {
	width: 70%;
}
.td-set {
	display: flex;
}
.select-set {
	margin-right: 15px;
}
.vee-set {
	position: relative;
	text-align: left;
	.vee-span {
		margin-top: 5px;
		color: red;
	}
}
</style>
